var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      ref: "modal",
      attrs: { "overlay-type": "login", "full-screen": "" },
      on: { data: _vm.setData },
    },
    [
      _c("div", { staticClass: "overlay-login" }, [
        _c("div", { staticClass: "overlay-login__wrapper" }, [
          _c("div", {
            staticClass: "overlay-login__info",
            domProps: { innerHTML: _vm._s(_vm.$t("login.infoHtml")) },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "overlay-login__forms" }, [
            _c("div", { staticClass: "overlay-login__tabs" }, [
              _c("button", {
                staticClass: "overlay-login__tab",
                class: {
                  "overlay-login__tab--active": _vm.activeTab == "login",
                },
                attrs: { type: "button" },
                domProps: { innerHTML: _vm._s(_vm.$t("login.loginTab")) },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.setActiveTab("login")
                  },
                },
              }),
              _vm._v(" "),
              _c("button", {
                staticClass: "overlay-login__tab",
                class: {
                  "overlay-login__tab--active": _vm.activeTab == "register",
                },
                attrs: { type: "button" },
                domProps: { innerHTML: _vm._s(_vm.$t("login.registerTab")) },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.setActiveTab("register")
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.activeTab == "login",
                    expression: "activeTab == 'login'",
                  },
                ],
                staticClass: "overlay-login__tab-content",
              },
              [
                _c("FormLogin", {
                  ref: "loginForm",
                  attrs: { "hide-title": "" },
                  on: { loggedIn: _vm.onLoggedIn },
                }),
                _vm._v(" "),
                _c("h3", {
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("login.loginRegisterTitle")),
                  },
                }),
                _vm._v(" "),
                _c("Button", {
                  attrs: {
                    type: "button",
                    level: "tertiary",
                    text: _vm.$t("login.loginRegisterButton"),
                    arrow: "",
                  },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.setActiveTab("register")
                    },
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.activeTab == "register",
                    expression: "activeTab == 'register'",
                  },
                ],
                staticClass: "overlay-login__tab-content",
              },
              [
                _c("FormRegister", {
                  ref: "registerForm",
                  attrs: { "hide-title": "" },
                }),
                _vm._v(" "),
                _c("h3", {
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("login.registerLoginTitle")),
                  },
                }),
                _vm._v(" "),
                _c("Button", {
                  attrs: {
                    type: "button",
                    level: "tertiary",
                    text: _vm.$t("login.registerLoginButton"),
                    arrow: "",
                  },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.setActiveTab("login")
                    },
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "overlay-login__pattern" }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }